import { LayoutDashboard, Building2, Wallet, UserRound } from 'lucide-react';

export const AGENT_LINKS = [
  { to: '/agent', end: true, label: 'Tableau de bord', icon: LayoutDashboard },
  { to: '/agent/bailleurs', label: 'Mes bailleurs', icon: Building2 },
  { to: '/agent/echeances', label: 'Échéances', icon: Wallet },
  { to: '/agent/profil', label: 'Mon profil', icon: UserRound },
];
